import React from 'react';
import parse from 'autosuggest-highlight/parse/index';
import match from 'autosuggest-highlight/match/index';

const highlightSuggestion = (suggestion, { query }) => {
  if (query.indexOf('״') !== -1) {
    suggestion.address = suggestion.address.replace(/"/g, '״');
  }
  if (query.indexOf('׳') !== -1) {
    suggestion.address = suggestion.address.replace(/'/g, '׳');
  }

  const suggestionText = `${suggestion.address}`;
  const formattedQuery = query.replace(/-/g, ' ');
  const matches = match(suggestionText, formattedQuery);
  const parts = parse(suggestionText, matches);

  parts.forEach((part, idx) => {
    part.id = idx;
  });

  return (
    <div className="suggestion-field">
      <span>
        {
          parts.map(part => (
            part.highlight
              ? <strong key={`suggestion_${part.id}`}>{part.text}</strong>
              : <span key={`suggestion_${part.id}`}>{part.text}</span>
          ))
        }
      </span>
    </div>
  );
};

export default highlightSuggestion;
